export enum EstateStatusKey {
  REFERRAL_PRE_FILLING = 'referral_pre_filling',
  ASSET_ASSESSMENT = 'asset_assessment',
  AWAITING_CLEARANCE = 'awaiting_clearance',
  AWAITING_T3_NOA = 'awaiting_t3_noa',
  CHURNED = 'churned',
  CLIENT_REVIEW = 'client_review',
  CLOSING_COMMUNICATION = 'closing_communication',
  CLOSING_LETTER_PREPARATION = 'closing_letter_preparation',
  COMPLETED = 'completed',
  COMPLETED_ACTING_FALL_IN = 'completed_acting_fall_in',
  COMPLETED_AR_CHURNED = 'completed_ar_churned',
  COMPLETED_DECEASED_NOT_ACTING = 'completed_deceased_not_acting',
  CLEARANCE_CERTIFICATE_PREP = 'clearance_certificate_prep',
  EARLY_CLOSURE = 'early_closure',
  ESTATE_PLAN_AND_INVENTORY = 'estate_plan_and_inventory',
  FINAL_ACCOUNTING = 'final_accounting',
  FINAL_DISCHARGE = 'final_discharge',
  FINAL_DISTRIBUTION = 'final_distribution',
  FIRST_NOTIFICATIONS = 'first_notifications',
  INTERIM_DISTRIBUTION = 'interim_distribution',
  INVENTORY = 'inventory',
  LIQUIDATION = 'liquidation',
  MAIL_FOLDER = 'mail_folder',
  NEW = 'new',
  PENDING_DOCUMENTS = 'pending_documents',
  PETITION_PREPARATION = 'petition_preparation',
  PETITION_PREPARED_WAITING_ON_CLIENT = 'petition_prepared_waiting_on_client',
  PETITION_FILED_WAITING = 'petition_filed_waiting',
  PLAN_MY_ESTATE = 'plan_my_estate',
  REVISING_PETITION = 'revising_petition',
  SECOND_NOTIFICATIONS = 'second_notifications',
  WILL_DRAFTING_AND_PREP = 'will_drafting_and_prep',
  WILL_PREP_EXTERNAL = 'will_prep_external',
  SMALL_ESTATE = 'small_estate',
  ESSENTIAL_POST_PROBATE = 'essential_post_probate',
  PLUS_POST_PROBATE = 'plus_post_probate',
  INTAKE = 'intake',
  SUPPORT_MEETING_BOOKED = 'support_meeting_booked',
  SUPPORT_MEETING_COMPLETED = 'support_meeting_completed',
  DISCOVERY = 'discovery',
  GUIDANCE = 'guidance',
  DECISIONS = 'decisions',
  SIGNATURES = 'signatures',
  UPLOADS = 'uploads',
  AR_ASSESSMENT = 'ar_assessment',
  AR_GUIDANCE = 'ar_guidance',
  AR_DECISIONS = 'ar_decisions',
  AR_WILL_PREP = 'ar_will_prep',
  AR_CLIENT_REVIEW = 'ar_client_review',
  AR_PENDING_SIGNATURES = 'ar_pending_signatures',
  AR_UPLOADS = 'ar_uploads',
  AR_AFFIDAVIT_OF_EXECUTION = 'ar_affidavit_of_execution',
  AR_WAITING_ON_ORIGINALS = 'ar_waiting_on_originals',
  NON_RESPONSIVE = 'non_responsive',
  REVISING_DOCUMENTS = 'revising_documents',
  DISENGAGED = 'disengaged',
  NBA_INTAKE = 'nba_intake',
  NBA_PENDING_SUBMISSION = 'nba_pending_submission',
  NBA_SUBMITTED = 'nba_submitted',
  NBA_CONDITIONAL = 'nba_conditional',
  POA_MANAGEMENT_YEAR_2 = 'poa_management_year_2',
  POA_MANAGEMENT_YEAR_3 = 'poa_management_year_3',
  POA_MANAGEMENT_YEAR_4 = 'poa_management_year_4',
  POA_MANAGEMENT_YEAR_5 = 'poa_management_year_5',
  AFFIDAVIT_OF_EXECUTION = 'affidavit_of_execution',
  WAITING_ON_ORIGINALS = 'waiting_on_originals',
  ON_HOLD = 'on_hold',
  PEER_REVIEW = 'peer_review',
  AUDIT = 'audit',
  AR_CONTACT = 'ar_contact',
  AR_SS_COMPLETED = 'ar_ss_completed',
  AR_NO_CHANGES = 'ar_no_changes',
  AR_GUIDANCE_CSM = 'ar_guidance_csm',
  AR_GUIDANCE_EPA = 'ar_guidance_epa'
}
